import React from "react";
import { ReferralModal } from "./referralModal";

const ReferralModalPartner = ({
  title = "Want to give us a try?",
  text = "Get 1 month of Mangomint on us, including free onboarding support and data transfer. Book a demo to speak with our team.",
  buttonText = "Sounds good!",
  buttonHref = null,
}) => {
  const { Title, Text, CloseButton } = ReferralModal;
  return (
    <>
      <ReferralModal referralType="partner">
        <Title>{title}</Title>
        <Text>{text}</Text>
        <CloseButton href={buttonHref}>{buttonText}</CloseButton>
      </ReferralModal>
    </>
  );
};

export { ReferralModalPartner };
